import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarValorEdificadoDs } from "../../DataSources";
import { Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import apiAxios from "../../api-axios";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  scoreId: undefined,
  opcaoScoreId: undefined,
};

export default class ValorEdificadoForm extends React.Component {
  constructor(props) {
    super(props);
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = { ...(_cadastroCorrente || template) };

    this.opcoesFatoresDs = [];
    this.valorEdificadoDs = criarValorEdificadoDs();

    this.fatoresCorretivosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: this.opcoesFatoresDs,
      valueExpr: "id",
      displayExpr: (item) => {
        if (item) {
          return `${item.score.descricao} - ${item.descricao}`;
        } else {
          return "Selecione...";
        }
      },
    };
  }

  componentDidMount() {
    apiAxios
      .get(`fatorescorretivos/opcoes/${UserInfo.getPrefeitura()}`)
      .then((response) => {
        response.data.data.map((item) => this.opcoesFatoresDs.push(item));
        if (_cadastroCorrente === undefined) {
          if (this.props.match.params.id !== undefined) {
            this.valorEdificadoDs
              .byKey(this.props.match.params.id)
              .then((data) => {
                if (data == undefined) {
                  notify("Valor edificado não encontrado.", "error");
                  this.props.history.push("/valoredificado");
                }
                this.setState(data);
              })
              .catch((error) => {
                ShowError(error.response.data);
                notify(error, "error", 2000);
                this.props.history.goBack();
              });
          }
        } else {
          this.setState({ ..._cadastroCorrente });
        }
        _cancelando = false;
      });
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={3}>
              <GroupItem caption="VALOR EDIFICADO" colSpan={3} colCount={3}>
                <SimpleItem
                  colSpan={2}
                  dataField={"opcaoScoreId"}
                  editorType={"dxLookup"}
                  editorOptions={this.fatoresCorretivosOptions}
                >
                  <Label text="Opção Fator" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"valor"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                  }}
                >
                  <Label text="Valor" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "none", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Imprimir"
                  type="default"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "none", marginLeft: "10px" }}>
                <Button text="Fechar" onClick={this.cancel} width={120} />
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.valorEdificadoDs, entidade)
      .then(
        function () {
          notify("Valor edificado lançado com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
